/* Homepage redesign 2026-10: slow logo marquee for sections/ei-brands.liquid.
   The server-rendered list stays the only accessible copy; clones are aria-hidden + inert.
   Skipped entirely for reduced motion and Save-Data (the static wrapped row stays).
   Perf: at load this only registers one IntersectionObserver per rail; the pause observer, resize
   listener and clone build start once the band is close, and the build measures once before writing. */
(function () {
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  if ((mq && mq.matches) || (navigator.connection && navigator.connection.saveData)) return;

  document.querySelectorAll('[data-ei-marquee]:not([data-ei-ready])').forEach(function (rail) {
    var track = rail.querySelector('.ei-brands__track');
    var list = track && track.querySelector('.ei-brands__list');
    if (!list) return;
    rail.setAttribute('data-ei-ready', '');
    var speed = parseFloat(rail.getAttribute('data-speed')) || 26;
    var lastW = 0;

    function clearClones() {
      track.querySelectorAll('.ei-brands__list[data-clone]').forEach(function (c) { c.remove(); });
    }
    function build() {
      rail.classList.add('is-marquee');
      /* Reads first (one layout), then writes. Clones sit after the list, so they never change its width. */
      var railW = rail.getBoundingClientRect().width;
      if (Math.abs(railW - lastW) < 2 && track.querySelector('[data-clone]')) return;
      var listW = list.getBoundingClientRect().width;
      if (!listW) return;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      lastW = railW;
      clearClones();
      var copies = Math.max(1, Math.ceil(railW / (listW + gap)));
      var frag = document.createDocumentFragment();
      for (var i = 0; i < copies; i++) {
        var c = list.cloneNode(true);
        c.setAttribute('data-clone', '');
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('inert', '');
        c.querySelectorAll('a').forEach(function (a) { a.setAttribute('tabindex', '-1'); });
        c.querySelectorAll('img').forEach(function (img) { img.setAttribute('alt', ''); img.setAttribute('loading', 'eager'); });
        c.querySelectorAll('[data-shopify-editor-block]').forEach(function (el) { el.removeAttribute('data-shopify-editor-block'); });
        frag.appendChild(c);
      }
      track.appendChild(frag);
      var shift = listW + gap;
      rail.style.setProperty('--ei-brands-shift', shift + 'px');
      rail.style.setProperty('--ei-brands-dur', (shift / speed).toFixed(2) + 's');
    }

    var started = false;
    var inView = false;
    function syncPause() { rail.classList.toggle('is-paused', !inView || document.hidden); }
    function start() {
      if (started) return;
      started = true;
      /* Pause while off screen or in a hidden tab; rebuild on resize. Wired up only from here on. */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { inView = e.isIntersecting; syncPause(); });
        }).observe(rail);
      } else {
        inView = true;
      }
      document.addEventListener('visibilitychange', syncPause);
      var t;
      window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(build, 200); });
      /* Logos are lazy; once the band is close, load them and build with real widths. */
      var imgs = Array.prototype.slice.call(list.querySelectorAll('img'));
      imgs.forEach(function (img) { img.loading = 'eager'; });
      Promise.all(imgs.map(function (img) {
        return img.complete ? Promise.resolve() : new Promise(function (r) { img.addEventListener('load', r, { once: true }); img.addEventListener('error', r, { once: true }); });
      })).then(build);
    }

    if ('IntersectionObserver' in window) {
      var near = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { near.disconnect(); start(); } });
      }, { rootMargin: '400px 0px' });
      near.observe(rail);
    } else {
      start();
    }

    if (mq && mq.addEventListener) {
      mq.addEventListener('change', function () {
        if (mq.matches) { clearClones(); rail.classList.remove('is-marquee'); lastW = 0; }
        else if (started) { build(); }
      });
    }
  });
})();
